import { classifications, occupations, orgs } from "@/api/base";
import _ from "lodash";

export const PREVIEW_URL = "preview-url";
const previewUrl = localStorage.getItem(PREVIEW_URL) || null;
const state = () => ({
    orgs: [],
    previewUrl: previewUrl,
    classifications: [],
    occupations: []
});

const getters = {
    orgs: state => {
        return state.orgs;
    },
    previewUrl: state => {
        return state.previewUrl;
    },
    classifications: state => {
        return state.classifications;
    },
    occupations: state => {
        return state.occupations;
    }
};

const actions = {
    mapperOrgs: ({ commit }) => {
        orgs().then(resp => {
            if (resp.data) {
                const orgs = _.map(resp.data.data, data => {
                    return {
                        id: data.id,
                        name: data.name
                    };
                });
                commit("orgs", orgs);
            }
        });
    },
    mapperClassifications: ({ commit, state }, { params }) => {
        return classifications(params).then(resp => {
            if (resp.data) {
                const mapperClassifications = _.map(resp.data.data, data => {
                    return {
                        id: data.id,
                        name: data.name
                    };
                });
                commit("classifications", mapperClassifications);
            }
        });
    },
    mapperOccupations: ({ commit }, { params }) => {
        occupations(params).then(resp => {
            if (resp.data) {
                const mapperOccupations = _.map(resp.data.data, data => {
                    return {
                        id: data.id,
                        name: data.occupationName
                    };
                });
                commit("occupations", mapperOccupations);
            }
        });
    }
};

const mutations = {
    orgs: (state, orgs) => {
        state.orgs = orgs;
    },
    previewUrl: (state, previewUrl) => {
        localStorage.setItem(PREVIEW_URL, previewUrl);
        state.previewUrl = previewUrl;
    },
    classifications: (state, classifications) => {
        state.classifications = classifications;
    },
    occupations: (state, occupations) => {
        state.occupations = occupations;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
